/**
 * License management enums
 * @see Issue #238 - Partner Companies B2B Model
 */

/**
 * Type of business license
 */
export enum BusinessLicenseType {
  NMLS_COMPANY = 'nmls_company',
  STATE_LENDER = 'state_lender',
  STATE_BROKER = 'state_broker',
  STATE_SERVICER = 'state_servicer',
}

/**
 * Type of individual user license
 */
export enum UserLicenseType {
  NMLS_INDIVIDUAL = 'nmls_individual',
  STATE_LOAN_OFFICER = 'state_loan_officer',
  STATE_BROKER = 'state_broker',
}

/**
 * Status of a license
 */
export enum LicenseStatus {
  ACTIVE = 'active',
  EXPIRED = 'expired',
  PENDING_RENEWAL = 'pending_renewal',
  SUSPENDED = 'suspended',
  REVOKED = 'revoked',
  PENDING_VERIFICATION = 'pending_verification',
  VERIFIED = 'verified',
}

/**
 * Business license type display names
 */
export const BUSINESS_LICENSE_TYPE_NAMES: Record<BusinessLicenseType, string> = {
  [BusinessLicenseType.NMLS_COMPANY]: 'NMLS Company License',
  [BusinessLicenseType.STATE_LENDER]: 'State Lender License',
  [BusinessLicenseType.STATE_BROKER]: 'State Broker License',
  [BusinessLicenseType.STATE_SERVICER]: 'State Servicer License',
};

/**
 * User license type display names
 */
export const USER_LICENSE_TYPE_NAMES: Record<UserLicenseType, string> = {
  [UserLicenseType.NMLS_INDIVIDUAL]: 'NMLS Individual License',
  [UserLicenseType.STATE_LOAN_OFFICER]: 'State Loan Officer License',
  [UserLicenseType.STATE_BROKER]: 'State Broker License',
};

/**
 * License status display names
 */
export const LICENSE_STATUS_NAMES: Record<LicenseStatus, string> = {
  [LicenseStatus.ACTIVE]: 'Active',
  [LicenseStatus.EXPIRED]: 'Expired',
  [LicenseStatus.PENDING_RENEWAL]: 'Pending Renewal',
  [LicenseStatus.SUSPENDED]: 'Suspended',
  [LicenseStatus.REVOKED]: 'Revoked',
  [LicenseStatus.PENDING_VERIFICATION]: 'Pending Verification',
  [LicenseStatus.VERIFIED]: 'Verified',
};
